<template>
  <div class="change-password">
    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="旧密码" prop="oldPass">
        <el-input type="password" v-model="ruleForm.oldPass" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="pass">
        <el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="checkPass">
        <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import API from '../lib/API'
export default {
  name: 'OrderList',
  data() {
      var validateOldPass = (rule, value, callback) => {
        if (value.length < 6 || value.length > 20) {
          return callback(new Error('请输入6~20位密码'));
        }
        callback();
      };
      var validatePass = (rule, value, callback) => {
        if (value.length < 6 || value.length > 20) {
          callback(new Error('请输入6~20位密码'));
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value.length < 6 || value.length > 20) {
          callback(new Error('请输入6~20位密码'));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        ruleForm: {
          pass: '',
          checkPass: '',
          oldPass: ''
        },
        rules: {
          pass: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ],
          oldPass: [
            { validator: validateOldPass, trigger: 'blur' }
          ]
        }
      };
    },
    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.changePass()
          } else {
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      changePass() {
        new API(this).POST({
          url: '/user/updateMyPassword',
          params: {
            oldPwd: this.ruleForm.oldPass,
            comfirmPwd: this.ruleForm.checkPass,
            newPwd: this.ruleForm.pass
          },
          cb: res => {
            this.$notify({
              title: '修改密码成功，请重新登录',
              type: 'success',
              duration: 2000
            });
            localStorage.clear();
            // setTimeout(() => {
            //   location.reload();
            // }, 1000)
            this.$router.push({name: 'Login'})
          }
        })
      }
    }
}
</script>
<style lang="less" scoped>
.change-password {
  width:400px;
  margin:40px auto;
  .el-input {
    width:100%!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ChangePassword.vue